import PropTypes from 'prop-types'

const AriaLivePropType = PropTypes.oneOf(['polite', 'assertive'])

export default AriaLivePropType
